import ChatPreview from "@/components/proactive-chats/chat-preview/chat-preview";
import EasySetupSettings from "@/components/proactive-chats/easy-setup-settings/easy-setup-settings";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import useGlobalPermission from "@/store/user-permissions";
import { AlertCircle } from "lucide-react";

const EasySetup = () => {
    const { permissionList } = useGlobalPermission();
    const proactivePermission = permissionList.find((item) => item.module.name === "Proactive_Chat");
    return (
        <Card className="p-8 shadow-none relative">
            <div className={cn("grid grid-cols-1 lg:grid-cols-2", !proactivePermission?.can_create && "blur-md")}>
                <EasySetupSettings className={"order-2 border-t pr-6 pt-4 lg:order-1 lg:border-r lg:border-t-0 lg:pt-0"} />
                <ChatPreview className={"order-1 h-full pb-16 lg:order-2 lg:pb-8 lg:pl-6"} />
            </div>
            {!proactivePermission?.can_create && (
                <Alert variant="destructive" className="absolute z-10 top-1/2 right-1/2 translate-x-1/2 -translate-y-1/2 max-w-2xl">
                    <AlertCircle className="h-4 w-4" />
                    <AlertTitle>Error</AlertTitle>
                    <AlertDescription>You do not have permission to view this list!</AlertDescription>
                </Alert>
            )}
        </Card>
    );
};

export default EasySetup;
